import React, { useEffect, useState, useRef } from "react";
import Select from 'react-select'
import {
  SlOption,
  SlSelect,
  SlButton,
  SlInput,
  SlIcon,
  SlTooltip
} from "@shoelace-style/shoelace/dist/react";
// import { languageOptions } from "../../utils/constants";
import { debounce } from "../../utils/Debounce";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import API from "../../services/api";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import AddBrand from "./AddBrand";
import { formatDate } from "../../utils/dateFormat";
import Merge from "./Merge";
import POCC from "./POC";
import AssignBrand from "./AssignBrand";
import Accordion from "./Accordion";
import { BrandsTypes, getGenerateUrl, roles } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import { CSVLink } from "react-csv";
import AssignTarget from "./AssignTarget";
function Brands() {
  const [language, setLanguage] = useState("all");
  const [search, setSearch] = useState("");
  const [brandData, setBrandData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [add, setAdd] = useState(false);
  const [merge, setMerge] = useState(false);
  const [mergeIds, setMergeIds] = useState([]);
  const [POC, setPOC] = useState();
  const [assign, setAssign] = useState(false);
  const [actionId, setActionId] = useState();
  const [viewPoc, setviewPoc] = useState(false);
  const [flag, setFlag] = useState("add");
  const [editData, setEditdata] = useState();
  const [categories, setCategories] = useState([]);
  const [adType, setAdType] = useState(["1"]);
  const [location, setLocation] = useState("all");
  const [brandLocations, setBrandLocations] = useState([]);
  const [brandAssignedStatus, setBrandAssignedStatus] = useState("all");
  const [salesList, setSaleslist] = useState([]);
  const [sales_id, setSales_id] = useState(null);
  const [target, setTarget] = useState(false);
  const [statObj, setStatObj] = useState({
    total: 0,
    assigned: 0,
    unassigned:0
  });
  const [downloadData, setDownloadData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [sales_person_id, set_Sales_Person_Id] = useState(null);
  const csvLinkRef = useRef();
  let csvHeaders = [
    { label: "Brand Name", key: "brand_name" },
    { label: "Alias Names", key: "alias_names" },
    { label: "Assigned to", key: "assigned_to" },
    { label: "Type", key: "brand_ad_type" },
    { label: "Location", key: "brand_location" },
    { label: "BrandType", key: "brand_type"}
]; // Create a ref for CSVLink
  // const langugageFilterChange = (e) => {
  //   setLanguage(e.target.value);
  // };
  const searchBrand = (e) => {
    setSearch(e.target.value);
  };
  const loadCategories = async () => {
    if (localStorage.getItem("role") === roles.b2b || localStorage.getItem("role") === roles.salesperson) {
      // setLoader(true);
      const response = await API({
        url: `/birdview/newspapers_categories`,
        method: "POST",
        responseType: "json",
      });
      if (response?.code === 200) {
        setCategories(response?.data?.result);
        // setLoader(false);
      } else {
        Toast("error", response?.data?.message);
      }
    }
  };
  const getBrands = async (page = 0) => {
    setLoader(true);
    try {
      let res = await API({
        url: "/birdview/getBrands",
        method: "POST",
        responseType: "json",
        data: {
          language,
          search,
          page,
          adType,
          location,
          brandAssignedStatus,
          sales_id,
          // limit: config.PER_PAGE,
          limit: 100,
        },
      });
      if (res.code === 200) {
        setBrandData(res.data?.result?.data);
        setTotalPages(Math.ceil(res.data?.result?.totalCount / 100));
        setStatObj({
          total: res.data?.result?.totalCount,
          assigned: res.data?.result?.assignedCount,
          unassigned: Math.max(res.data?.result?.totalCount -res.data?.result?.assignedCount , 0),
        });
        getBrandsLocations();
      }
      else{
        setBrandData([])
        setTotalPages(0)
        Toast('error', res.message)
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };

  const getBrandsLocations = async (page = 0) => {
    setLoader(true);
    try {
      let res = await API({
        url: "/birdview/brandsLocations",
        method: "POST",
        responseType: "json",
      });
      if (res.code === 200) {
        setBrandLocations([{label: "All", value: 'all'},{label: "Blanks", value: null},...res.data?.result]);
      }
    } catch (error) {
      console.error(error);
    }
    setLoader(false);
  };
  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    getBrands(event.selected);
  };
  const handleCheckboxChange = (brand) => {
    setMergeIds((prevSelectedRows) => {
      const index = prevSelectedRows.findIndex((item) => item.id === brand.id);
      if (index !== -1) {
        return prevSelectedRows.filter((item, idx) => idx !== index);
      } else {
        return [...prevSelectedRows, brand];
      }
    });
  };

  const downloadBrands = async () => {
    setDownloadLoader(true);
    try {
      let res = await API({
        url: "/birdview/downloadBrands",
        method: "POST",
        responseType: "json",
        data: {
          language,
          search,
          adType,
          location,
          brandAssignedStatus,
          sales_id,
        },
      });
      if (res.code === 200) {
        setDownloadData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
    finally{
      setDownloadLoader(false);
    }
  };
  const fetchPOC = async (brand) => {
    try {
      let res = await API({
        url: "/b2b_contacts/getBrandContacts",
        method: "POST",
        responseType: "json",
        data: {
          brand_id: brand,
        },
      });
      if (res.code === 200) {
        setPOC(res.data.result);
        setviewPoc(true);
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    getBrands(0);
    loadCategories();
  }, [language, search, adType, location, brandAssignedStatus, sales_id]);

  const defaultValue = (options, value) => {
    return options ? options.filter((option) => option.value === value) : "";
  };

  const getSales = async (department_id) => {
    try {
      let res = await API({
        url: "/user/sales_persons/getSalesByDepartment",
        method: "POST",
        responseType: "json",
        data: {
          department_id,
        },
      });
      setSaleslist([{label: "All", value: 0},...res.data]);
      return res.data;
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(()=>{
    getSales();
  },[])
  useEffect(() => {
    if (downloadData.length) {
        csvLinkRef?.current?.link?.click();
        setDownloadData([]);
    }
  }, [downloadData]);
  return (
    <>
      <div className="d-flex justify-between">
        <h4>Brands</h4>
        <div className="d-flex justify-end flex-wrap items-end gap-3">
          {/* <SlSelect
            value={language}
            onSlChange={langugageFilterChange}
            size="small"
            label="Language"
          >
            <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
            <SlOption value="all">All</SlOption>
            {languageOptions.map((item) => {
              return <SlOption value={item.value}>{item.label}</SlOption>;
            })}
          </SlSelect> */}
          <div>
            <SlSelect
              className='w-full'
              placeholder="Select Brand Type"
              name="adType"
              size="small"
              value={adType}
              multiple={true}
              label="Brand Type"
              onSlChange={(e) => { (setAdType(e.target.value)) }}
            >
              {BrandsTypes?.map((item) => {
                return <SlOption value={item.value}>{item.label}</SlOption>;
              })}

            </SlSelect>
          </div>

          <div>
            <SlSelect
              className='w-full'
              placeholder="Select Brand Assigned Status"
              name="brandAssignedStatus"
              size="small"
              label="Assinged Status"
              value={brandAssignedStatus}
              onSlChange={(e) => { (setBrandAssignedStatus(e.target.value)) }}
            >
              <SlOption value="all">All</SlOption>
              <SlOption value="assigned">Assigned</SlOption>
              <SlOption value="unassigned">Unassigned</SlOption>
            </SlSelect>
          </div>

          
          <SlInput
            size="small"
            placeholder="Search brand"
            type="text"
            label="Search Brand"
            onSlInput={debounce(searchBrand, 500)}
          >
            <SlIcon library="lucide" name="search" slot="prefix"></SlIcon>
          </SlInput>

          <div>
          <Select
                className='w-36'
                placeholder="Location"
                name="location"
                size="small"
                value={defaultValue(brandLocations, location)}
                onChange={(e) => { setLocation(e.value)}}
                options={brandLocations}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // or any other high value to ensure it is above other elements
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    zIndex: 9999, // apply z-index to menuList if needed
                  }),
                }}
            />
          </div>

          <div>
          <Select
                // className='w-36'
                placeholder="Sales person"
                value={defaultValue(salesList, sales_id)}
                onChange={(selected) => {
                  setSales_id(selected.value)
                }}
                options={salesList}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 9999, // or any other high value to ensure it is above other elements
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    zIndex: 9999, // apply z-index to menuList if needed
                  }),
                }}
              ></Select>
          </div>
          {localStorage.getItem('role') === roles.b2b ? <>
          <SlButton
            variant="primary"
            size="small"
            onClick={() => {
              setAdd(true);
              setFlag("add");
            }}
          >
            Add
          </SlButton>
          <CSVLink
              data={downloadData.map(
                  (brand) => {
                      
                     
                      let obj = {
                        brand_name:brand.brand_name,
                        alias_names:brand.alias_names,
                        assigned_to:brand.sales_details[0]?.assigned_to,
                        brand_ad_type:brand.brand_ad_type,
                        brand_location:brand.brand_location,
                        brand_type: BrandsTypes.find((row) => row.value === brand.brand_type )?.label || '-',
                      };
                     
                      return obj;
                  }
              )}
              headers={csvHeaders}
              filename={"brands.csv"}
              ref={csvLinkRef} // Assign the ref to the CSVLink component
          ></CSVLink>
          {downloadLoader ? <div className="spinner-border text-primary" role="status"  >
            <span className="visually-hidden">Loading...</span>
          </div>:<div className="d-flex items-center justify-center bg-slate-200 rounded w-8 h-8">
            <sl-tooltip content="Download brands">
              <SlIcon library="lucide" name="download" onClick={() => downloadBrands()} className="hover:cursor-pointer hover:text-sky-400 transition-all ease-in-out">
              </SlIcon>
            </sl-tooltip>
          </div>}
          
          {mergeIds.length >= 1 ? (
            <SlButton
              variant="primary"
              size="small"
              onClick={() => setMerge(true)}
            >
              Merge
            </SlButton>
          ) : null}
          </> : null}
        </div>
      </div>
      <div className="justify-end ml-auto w-72 mt-2">
        <table className="table-bordered table">
          <thead>
            <tr>
              <th>Brands</th>
              <th>Assigned</th>
              <th>Unassigned</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td>{statObj.total}</td>
                <td>{statObj.assigned}</td>
                <td>{statObj.unassigned}</td>
              </tr>
              </tbody>
              </table>
        </div>
      <div className="overflow-auto max-h-[75vh] mt-3 relative">
        <table className="table-bordered table">
          <thead className="bg-gray-100 sticky top-0 z-10">
            <tr>
              {localStorage.getItem('role') === roles.b2b ? <th></th> : null}
              <th>S.NO</th>
              <th>Brand Name</th>
              <th>BrandType</th>
              <th>Location</th>
              <th>Assigned To</th>
              <th>Incentive Rules</th>
              <th>Created Date</th>
              <th>Alias Names</th>
              {localStorage.getItem('role') === roles.b2b ? <th>Actions</th> : null}
              <th>Status</th>
            </tr>
          </thead>
          {brandData?.length && !loader ? (
            <tbody>
              {brandData.map((item, index) => {
                return (
                  <>
                    <tr key={item.brand_id}>
                    {localStorage.getItem('role') === roles.b2b ? <td>
                        <input
                          type="checkbox"
                          className="form-check"
                          checked={mergeIds
                            .map((obj) => obj.id)
                            .includes(item.brand_id)}
                          onChange={(e) =>
                            handleCheckboxChange({
                              id: item.brand_id,
                              label: item.brand_name,
                            })
                          }
                        ></input>
                      </td>: null}
                      <td>{index + 1}</td>
                      <td className="capitalize">
                        <div className="d-flex gap-2 items-center justify-start">
                        {item?.logo_url || getGenerateUrl(item.brand_name) ?  
                            <SlTooltip content={item.brand_name} className="z-10">
                          <img src={item?.logo_url || getGenerateUrl(item.brand_name) } alt="logo" className="w-8"/>
                          </SlTooltip>
                          : null}
                          <label>{item.brand_name}</label>
                        </div>
                      </td>
                      <td>{BrandsTypes.find((row) => row.value === item.brand_type )?.label || '-'}</td>
                      <td>{item.brand_location || "-"}</td>
                      <td>
                       <Accordion data={item.sales_details} brand={item} loadData={getBrands}/>
                      </td>
                      <td>{item.incentives_rules || "-"}</td>
                      <td>{formatDate(item.date)}</td>
                      <td>{item.alias_names}</td>
                      {localStorage.getItem('role') === roles.b2b ? <td className="d-flex gap-3">
                        <>
                          <sl-tooltip content="Edit Brand">
                            <sl-icon-button
                              library="lucide"
                              name="edit"
                              onClick={() => {
                                setFlag("edit");
                                setAdd(true)
                                setEditdata(item)
                                setActionId({
                                  id: item.brand_id,
                                  name: item.brand_name,
                                });
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                          <sl-tooltip content="Assign Brand">
                            <sl-icon-button
                              library="lucide"
                              name="forward"
                              onClick={() => {
                                setAssign(true);
                                setActionId({
                                  id: item.brand_id,
                                  name: item.brand_name,
                                });
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                          <sl-tooltip content="Assign Target">
                            <sl-icon-button
                            library="lucide"
                            name="indian-rupee"
                            onClick={() => {
                                setTarget(true);
                                setActionId({
                                  id: item.brand_id,
                                  name: item.brand_name,
                                });
                                set_Sales_Person_Id(item.sales_person_id);
                              }}
                              ></sl-icon-button>
                              </sl-tooltip>
                          <sl-tooltip content="View POC">
                            <sl-icon-button
                              library="lucide"
                              name="eye"
                              onClick={() => {
                                fetchPOC(item.brand_id);
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                        </>
                      </td> : null}

                      <td>
                        <span
                          className={
                            item.status === 1
                              ? "bg-green-200 px-3 py-1 rounded-lg text-green-700"
                              : "bg-red-200 px-3 rounded-md py-1 text-red-500"
                          }
                        >
                          {item.status === 1 ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  </>
                );
              })}
            </tbody>
          ) : !brandData?.length && !loader ? (
            <NoDataFound colspan="10" />
          ) : (
            <TableLoader colspan="10" />
          )}
        </table>
        
      </div>
      <div className=" right-fixed mt-4">
          {totalPages > 1 && (
            <Paginator
              pageCount={totalPages}
              handlePageClick={handlePageClick}
              forcePage={currentPage}
            />
          )}
        </div>
      {add && <AddBrand show={add} setShow={setAdd} flag={flag} actionId={actionId} setActionId={setActionId} loadData={getBrands} editData={editData} setEditData={setEditdata} categories={categories} currentPage={currentPage} setCurrentPage={setCurrentPage}/>}
      {merge && (
        <Merge
          show={merge}
          setShow={setMerge}
          ids={mergeIds}
          setIds={setMergeIds}
          loadData={getBrands}
        />
      )}
      {viewPoc && <POCC show={viewPoc} setShow={setviewPoc} contacts={POC} />}
      {assign && (
        <AssignBrand
          show={assign}
          setShow={setAssign}
          loadData={getBrands}
          actionId={actionId}
          setActionId={setActionId}
          currentPage={currentPage}
        />
      )}
      {target && <AssignTarget show={target} setShow={setTarget} actionId={actionId}  sales_person_id={sales_person_id}/>}
    </>
  );
}

export default Brands;
